import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aspcontact',
  templateUrl: './aspcontact.component.html',
  styleUrls: ['./aspcontact.component.scss']
})
export class AspcontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
